export default __webpack_public_path__ + "3b4b3ff9d0419bf3e8be8d58954c5af3.svg";